import React from "react";
import { convertToTwoDecimals } from "../../../shared/utility";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export default function MixedCartonSourceItemsTable(props) {
  const { sourceItemsData } = props;

  const bodyFormatPLU = (item) => {
    return <p>{item.manufactured_product?.plu || "-"}</p>;
  };

  const bodyFormatProductName = (item) => {
    return <p>{item.manufactured_product?.product_name || "-"}</p>;
  };

  const bodyFormatLotNumber = (item) => {
    return <p>{item.manufactured_product?.lot_number || "-"}</p>;
  };

  const bodyFormatNetWeightKg = (item) => {
    return (
      <p>
        {item.net_weight_kg != null
          ? convertToTwoDecimals(item.net_weight_kg)
          : "-"}
      </p>
    );
  };

  const bodyFormatNetWeightLbs = (item) => {
    return (
      <p>
        {item.net_weight_lbs != null
          ? convertToTwoDecimals(item.net_weight_lbs)
          : "-"}
      </p>
    );
  };

  const bodyFormatPieceCount = (item) => {
    return (
      <p>
        {item.piece_count != null
          ? convertToTwoDecimals(item.piece_count, 0)
          : "-"}
      </p>
    );
  };

  const bodyFormatUnitCost = (item) => {
    return (
      <p>
        {item.unit_cost != null
          ? `$${convertToTwoDecimals(item.unit_cost)}`
          : "-"}
      </p>
    );
  };

  const bodyFormatSubtotal = (item) => {
    return (
      <p>
        {item.subtotal_amount != null
          ? `$${convertToTwoDecimals(item.subtotal_amount)}`
          : "-"}
      </p>
    );
  };

  const bodyFormatBarcode = (item) => {
    const barcode = item.manufactured_product?.barcode;
    if (!barcode) {
      return <p>-</p>;
    }
    // Show last 9 digits of barcode
    const last9Digits = barcode.length >= 9 ? barcode.slice(-9) : barcode;
    return <p>{last9Digits}</p>;
  };

  if (!sourceItemsData || sourceItemsData.length === 0) {
    return null;
  }

  return (
    <div className="flow-root">
      <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8 space-y-2">
          <div className="overflow-hidden card-custom bg-white">
            <DataTable
              value={sourceItemsData}
              dataKey="id"
              tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm"
              cellClassName="p-2 border-1-bottom-gray text-sm"
            >
              <Column
                header="PLU"
                body={bodyFormatPLU}
                style={{ width: "8%" }}
              />
              <Column
                header="Product Name"
                body={bodyFormatProductName}
                style={{ width: "15%" }}
              />
              <Column
                header="Lot Number"
                body={bodyFormatLotNumber}
                style={{ width: "10%" }}
              />
              <Column
                header="Net Weight (kg)"
                body={bodyFormatNetWeightKg}
                style={{ width: "10%" }}
              />
              <Column
                header="Net Weight (lbs)"
                body={bodyFormatNetWeightLbs}
                style={{ width: "10%" }}
              />
              <Column
                header="Piece Count"
                body={bodyFormatPieceCount}
                style={{ width: "8%" }}
              />
              <Column
                header="Unit Cost"
                body={bodyFormatUnitCost}
                style={{ width: "8%" }}
              />
              <Column
                header="Subtotal"
                body={bodyFormatSubtotal}
                style={{ width: "8%" }}
              />
              <Column
                header="Serial"
                body={bodyFormatBarcode}
                style={{ width: "15%" }}
              />
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  );
}
